import Control from './control';
import merge from 'lodash-es/merge';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import get from 'lodash-es/get';
import pick from 'lodash-es/pick';
// import each from 'lodash-es/each';
import omit from 'lodash-es/omit';
import { getDefaultControlStyle, getDefaultControl } from './button.defaults';
import frameProps from '../css/frameProps';
import getDisabledStyle from '../css/disabledStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import defaultsDeep from 'lodash-es/defaultsDeep';

export default class Button extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this.addApi(this, 'text', () =>
      this._checkDataOption('text', get(this._controlOptions,'label.text','')),
      {formatter:'label.textFormatter'}
    );
    this.addApi(this, 'isToggle',
       () => this._controlOptions.isToggle
    );
    this.addApi(this, 'url', () => {
      // console.log(this._controlOptions);
      return this._checkDataOption(
        'url',
        this._controlOptions.icon && this._controlOptions.icon.url
      );
    }, {formatter:'icon.urlFormatter'});

    this.addApi(this, 'urlActive', () => get(this._controlOptions, 'iconActive.url',this.url));
  }

  onReady(){
    super.onReady();
    this.on('isChecked',()=>{
      if(this.isToggle){
        this.isActive = this.isChecked;        
      }
    });
  }

  renderElement() {
    const control = this;
    // console.log('render button, visible:', control.visible, control.options.visible);
    //const options = this._controlOptions;

    const instance = this.instance;
    const path = this.path;
    if (!control.el) {
      // console.log('control has no el yet', control.el);
      control.el = getDefaultControl();
      if (!control.isLayoutMode) {
        control.el.addEventListener('mouseover', function() {
          if (!control.isHover) {
            control.isHover = true;
            control.render();
          }
        });

        control.el.addEventListener('mousedown', function(event) {
          if (!control.isActive) {
            control.isActive = true;
            if(control.isToggle && event.button === 0) {
              control.isChecked = true;
            }
            
            control.render();
          }else if(control.isToggle  && event.button === 0){
            control.isActive = false;
            control.isChecked = false;
            control.render();
          }          
        });

        control.el.addEventListener('mouseup', function() {
          if (control.isActive&&(!control.isToggle|| event.button !== 0)) {
            control.isActive = false;
            control.render();
          }
        });

        control.el.addEventListener('mouseout', function() {
          if (control.isHover) {
            control.isHover = false;            
            control.render();
          }
        });

        control.el.addEventListener('focus', function() {
          control.isFocused = true;
          control.render();
          //console.log('button focus');
        });

        control.el.addEventListener('blur', function() {
          control.isFocused = false;
          control.render();
          //console.log('button blur');
        });

        control.el.addEventListener('click', function(ev) {
          if (control.options.trigger) {
          
            if (!isFunction(control.options.trigger)) {
              console.error("button's click trigger should be a function", control.options.trigger);
            } else {
              control.options.trigger.apply(this, [
                control._controlOptions,
                instance,
                control,
                path,
                ev,
              ]);
            }
          }

          if (control.options.event) {
          
            if (!isString(control.options.event)) {
              console.error("button's click event should be a string", control.options.event);
            } else {
              instance.fire(
                control.options.event,
                pick(control.options, [
                  'name',
                  'value.defaultValue',
                  'type',
                  'label',
                  'toggleGroup',
                  'gridElement',
                ]),
                control,
                path,
                ev
              );
            }
          }

          control.doResetReload();
        });
      }
    }

    // console.log('render button', control.options);
    var stylePatch = {};
    var bodyStylePatch = {};
    var iconStylePatch = {};
    var labelStylePatch = {};
    var defaultStyle = getDefaultControlStyle(control);
    var iconEl = control.el.getElementsByClassName('icon')[0];
    var labelEl = control.el.getElementsByClassName('label')[0];
    var bodyEl = control.el.getElementsByClassName('body')[0];
    // var frameProps = [
    //   'top',
    //   'left',
    //   'right',
    //   'bottom',
    //   'margin',
    //   'position',
    //   'display',
    //   'width',
    //   'height',
    // ];
    if (!control.options.label) {
      control.options.label = {};
    }

    if (control.options.label.visible === undefined) {
      control.options.label.visible = true;
    }

    if (!control.options.label.align) {
      control.options.label.align = 'center';
    }

    if (!control.options.icon) {
      control.options.icon = {};
    }

    if (control.options.icon.visible === undefined) {
      control.options.icon.visible = !!control.options.icon.url;
    }

    if (control.options.label.visible === undefined) {
      control.options.label.visible = !!control.options.label.text;
    }

    if (!control.options.icon.align) {
      control.options.icon.align = 'center';
    }

    if (control.options.icon.stretch == 'fit') {
      control.options.icon.stretch = '100% 100%';
    }

    if(control.options.iconActive){
      defaultsDeep(control.options.iconActive,control.options.icon);
    }

    // if(control.options.iconDisabled){
    //   defaultsDeep(control.options.iconDisabled,control.options.icon);
    // }

    let iconOptions = control.isActive && control.options.iconActive ? control.options.iconActive:control.options.icon;

    merge(stylePatch, defaultStyle.normal);
    merge(bodyStylePatch, defaultStyle.body.normal);

    if (control.options.label.visible) {
      merge(labelStylePatch, defaultStyle.label.normal);
      merge(labelStylePatch, defaultStyle.label[control.options.label.align]);
    } else {
      labelStylePatch.display = 'none';
    }

    if (control.options.style && control.options.style.normal) {
      merge(stylePatch, pick(control.options.style.normal, [...frameProps, 'overflow','transform']));
      merge(bodyStylePatch, omit(control.options.style.normal, [...frameProps,'transform']));
    }

    merge(stylePatch, control.frameStyle);

    if (
      control.options.label.visible &&
      control.options.label.style &&
      control.options.label.style.normal
    ) {
      merge(labelStylePatch, control.options.label.style.normal);
    }

    if (iconOptions.visible) {
      merge(iconStylePatch, defaultStyle.icon.normal);
      merge(iconStylePatch, defaultStyle.icon[iconOptions.position]);
      if (iconOptions.style) {
        merge(iconStylePatch, iconOptions.style.normal);
      }
    } else {
      iconStylePatch.display = 'none';
    }

    if (control.isFocused) {
      merge(stylePatch, defaultStyle.focused);
      merge(bodyStylePatch, defaultStyle.body.focused);
      if (control.options.style && control.options.style.focused) {
        merge(stylePatch, pick(control.options.style.focused, frameProps));
        merge(bodyStylePatch, omit(control.options.style.focused, frameProps));
      }

      if (control.options.label.visible) {
        merge(labelStylePatch, defaultStyle.label.focused);
        if (control.options.label.style && control.options.label.style.focused) {
          merge(labelStylePatch, control.options.label.style.focused);
        }
      }
    }

    if (control.isHover) {
      merge(stylePatch, defaultStyle.hover);
      merge(bodyStylePatch, defaultStyle.body.hover);
      if (control.options.style && control.options.style.hover) {
        merge(stylePatch, pick(control.options.style.hover, frameProps));
        merge(bodyStylePatch, omit(control.options.style.hover, frameProps));
      }

      if (control.options.label.visible) {
        merge(labelStylePatch, defaultStyle.label.hover);
        if (control.options.label.style && control.options.label.style.hover) {
          merge(labelStylePatch, control.options.label.style.hover);
        }
      }
    }

    if (control.isActive) {
      merge(stylePatch, defaultStyle.active);
      merge(bodyStylePatch, defaultStyle.body.active);
      if (control.options.style && control.options.style.active) {
        merge(stylePatch, pick(control.options.style.active, frameProps));
        merge(bodyStylePatch, omit(control.options.style.active, frameProps));
      }

      if (control.options.label.visible) {
        merge(labelStylePatch, defaultStyle.label.active);
        if (control.options.label.style && control.options.label.style.active) {
          merge(labelStylePatch, control.options.label.style.active);
        }
      }
    }

    if (control.disabled) {
      merge(stylePatch, getDisabledStyle());
      if (control.options.style && control.options.style.disabled) {
        merge(stylePatch, control.options.style.disabled);
      }

      if (control.isLayoutMode) {
        delete stylePatch.pointerEvents;
      }else{
        stylePatch.pointerEvents = 'none';
      }
      
      bodyStylePatch.pointerEvents = 'none';
      labelStylePatch.pointerEvents = 'none';
      iconStylePatch.pointerEvents = 'none';
    }    

    let iconUrl = control.isActive?control.urlActive:control.url;
    
    if (iconUrl) {
      const libicon = _.find(instance.options.icons, ['name', iconUrl]);
      if (libicon) {
        iconUrl = libicon.url;
      } else if (!iconUrl) {
        iconUrl = defaultStyle.icon.url;
      }
    }

    let scheme = lookAndFeel(control.options.lookAndFeel, stylePatch.height);
    scheme.iconUrl = iconUrl;

    scheme.iconPosition =
      (iconOptions.visible && iconOptions.position) || defaultStyle.icon.position;
    scheme.iconSize =
      (iconOptions.visible &&
        (iconOptions.size || iconOptions.stretch)) ||
      defaultStyle.icon.size;

    updateStyleByRef([stylePatch, bodyStylePatch, iconStylePatch, labelStylePatch], scheme);

    updateStyle(control.el, stylePatch, control.currentStyle);
    control.currentStyle = stylePatch;

    updateStyle(bodyEl, bodyStylePatch, control.currentBodyStyle);
    control.currentBodyStyle = bodyStylePatch;

    updateStyle(iconEl, iconStylePatch, control.currentIconStyle);
    control.currentIconStyle = iconStylePatch;

    updateStyle(labelEl, labelStylePatch, control.currentLabelStyle);
    control.currentLabelStyle = labelStylePatch;

    if (control.options.label.visible) {
      labelEl.innerHTML = control.text || '';
    }

    return control.el;
  }
}
